// @flow
import { useEffect } from 'react'
import { isAuthTokenValid } from '~/core/utils/functions'

type useLegacyAuthOptions = {
  skip?: boolean,
  onAuthSuccess?: () => void | Promise<void>,
  onAuthError?: (error: Error) => void
}

const useLegacyAuth = ({ skip, onAuthSuccess, onAuthError }: useLegacyAuthOptions) => {
  const handleLegacyAuth = async () => {
    try {
      if (!isAuthTokenValid()) {
        throw new Error('Unauthorized. Token expired or not valid')
      }

      if (typeof onAuthSuccess === 'function') {
        await onAuthSuccess()
      }
    } catch (error) {
      if (typeof onAuthError === 'function') {
        onAuthError(error)
      }
    }
  }

  useEffect(() => {
    if (!skip) {
      handleLegacyAuth()
    }
  }, [])
}

export { useLegacyAuth }
